import EmblaCarousel from 'embla-carousel'

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
    else prevBtn.setAttribute('disabled', 'disabled')

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
    else nextBtn.setAttribute('disabled', 'disabled')
  }

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState)

  return () => {
    prevBtn.removeAttribute('disabled')
    nextBtn.removeAttribute('disabled')
  }
}
// EmblaCarouselArrowButtons
const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev()
  }
  const scrollNext = () => {
    emblaApi.scrollNext()
  }
  prevBtn.addEventListener('click', scrollPrev, false)
  nextBtn.addEventListener('click', scrollNext, false)

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  )

  return () => {
    removeTogglePrevNextBtnsActive()
    prevBtn.removeEventListener('click', scrollPrev, false)
    nextBtn.removeEventListener('click', scrollNext, false)
  }
}
// EmblaCarouselSelectedSnapDisplay
const updateSelectedSnapDisplay = (emblaApi, snapDisplay) => {
  const updateSnapDisplay = (emblaApi) => {
    const selectedSnap = emblaApi.selectedScrollSnap()
    const snapCount = emblaApi.scrollSnapList().length
    snapDisplay.innerHTML = `${selectedSnap + 1} / ${snapCount}`
  }

  emblaApi.on('select', updateSnapDisplay).on('reInit', updateSnapDisplay)

  updateSnapDisplay(emblaApi)
}

// addThumbBtnsClickHandlers
const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index)
  )

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener('click', scrollToIndex[index], false)
  })

  return () => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener('click', scrollToIndex[index], false)
    })
  }
}

//addToggleThumbBtnsActive
const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
    const previous = emblaApiMain.previousScrollSnap()
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected')
    slidesThumbs[selected].classList.add('embla-thumbs__slide--selected')
  }

  emblaApiMain.on('select', toggleThumbBtnsState)
  emblaApiThumb.on('init', toggleThumbBtnsState)

  return () => {
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected')
  }
}
// Carousel recommandation -----------------------------
const emblaNodes = document.querySelectorAll('.carousel-recommendations .embla')

emblaNodes.forEach((emblaNode, index) => {
  if (emblaNode) {
    let OPTIONS = { dragFree: true }

    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
    const nextBtnNode = emblaNode.querySelector('.embla__button--next')
    const snapDisplayNode = emblaNode.querySelector('.embla__selected-snap-display')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtnNode,
      nextBtnNode
    )
    updateSelectedSnapDisplay(emblaApi, snapDisplayNode)

    emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
  }
})

// Carousel Thumbs --------------------------------------
function getThumbsAxis() {
  return window.matchMedia('(min-width: 992px)').matches ? 'y' : 'x'
}

function initCarouselThumbs() {
  // The PDP rewrite scopes thumbs inside `.pdp-stage`, but legacy callers
  // (and the JS-rendered fallback below) still use `.product-img` /
  // `.product-thumbnails`. Try them in order.
  const viewportNodeMainCarousel = document.querySelector(
    '.pdp-stage .embla__viewport, .product-img .embla__viewport, .product-thumbnails .embla__viewport'
  )
  if (!viewportNodeMainCarousel) return

  const viewportNodeThumbCarousel = document.querySelector('.embla-thumbs__viewport')
  if (!viewportNodeThumbCarousel) return

  const OPTIONS = {}
  const OPTIONS_THUMBS = {
    containScroll: 'keepSnaps',
    dragFree: true,
    axis: getThumbsAxis()
  }

  const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS)
  const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS)

  const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
    emblaApiMain,
    emblaApiThumb
  )
  const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
    emblaApiMain,
    emblaApiThumb
  )

  emblaApiMain
    .on('destroy', removeThumbBtnsClickHandlers)
    .on('destroy', removeToggleThumbBtnsActive)

  emblaApiThumb
    .on('destroy', removeThumbBtnsClickHandlers)
    .on('destroy', removeToggleThumbBtnsActive)

  // Re-init thumbs when the lg breakpoint is crossed so axis flips between
  // vertical (desktop rail) and horizontal (mobile strip).
  let currentAxis = OPTIONS_THUMBS.axis
  const onResize = function () {
    const newAxis = getThumbsAxis()
    if (newAxis !== currentAxis) {
      currentAxis = newAxis
      emblaApiThumb.reInit({ ...OPTIONS_THUMBS, axis: newAxis })
    }
  }
  window.addEventListener('resize', onResize)

  emblaApiThumb.on('destroy', function () {
    window.removeEventListener('resize', onResize)
  })
}
// Carousel Thumbs --------------------------------------
initCarouselThumbs();

// Function to generate carousel HTML
function generateCarouselHTML(productId, images) {
  var carouselHTML = `
  <span class="flag"><img src="static/images/img6.png" title="" alt=""></span>
  <div id="product-images-${productId}" class="product-thumbnails">
      <div class="embla">
          <div class="embla__viewport">
              <div class="embla__container">`;

  images.forEach(function(image, index) {
      carouselHTML += `
      <div class="embla__slide">
          <div class="embla__slide__number">
              <div class="embed-responsive">
                  <div class="embed-responsive-item">
                      <img class="d-block w-100" src="${image.url}" title="${image.title}" alt="${image.alt}" data-holder-rendered="true">
                  </div>
              </div>
          </div>
      </div>`;
  });

  carouselHTML += `
              </div>
          </div>
          <div class="embla-thumbs">
              <div class="embla-thumbs__viewport">
                  <div class="embla-thumbs__container">`;

  images.forEach(function(image, index) {
      carouselHTML += `
      <div class="embla-thumbs__slide ${index === 0 ? 'embla-thumbs__slide--selected' : ''}">
          <button type="button" class="embla-thumbs__slide__number">
              <div class="embed-responsive">
                  <div class="embed-responsive-item">
                      <img class="d-block w-100" src="${image.url}" title="${image.title}" alt="${image.alt}" data-holder-rendered="true">
                  </div>
              </div>
          </button>
      </div>`;
  });

  carouselHTML += `
                  </div>
              </div>
          </div>
      </div>
  </div>`;

  return carouselHTML;
}

$('body').on('product:updateImages', function (event, response) {
  if (response && response.images.length > 0) {
    var carouselHTML = generateCarouselHTML(response.productId, response.images);
    $('.product-img').empty().append(carouselHTML);
    // Carousel Thumbs --------------------------------------
    initCarouselThumbs();
  }
});